

































































































































































































































































































































































import Vue from "vue"
import EntityDialog, { IEntityDialog } from "@/components/entity-dialog/EntityDialog.vue"
import { EntityService } from "@/model/service/entity-service"
import { ApplicationEntity } from "@/model/entity/application-entity"
import { Page } from "@/model/dto/page"
import { AxiosResponse } from "axios"
import moment from "moment"
import { DatatableEntity } from "@/model/entity/datatable-entity"
import { FieldDescription, FieldTypeEnum } from "@/model/entity/field-descriptor"
import { CreateParcelModel } from "@/model/new-parcel-model/create-parcel-model"
import { Filter } from "@/model/dto/filter"
import { saveAs } from "file-saver"

interface DatatableMethods {
  handleSizeChange(): void
  clearSelection(): void
  refreshData(): void

  addFilter(field: string, filter: any): void
}

interface DatatableData {
  page: number
  size: number
  total: number
  clickedEntity: ApplicationEntity | null
  items: DatatableEntity[]
  selectedItems: DatatableEntity[]
  windowHeight: number
  filtersVisible: boolean
  isCodFilterEnabled: boolean
  sort: any
}

interface DatatableProps {
  entityService: EntityService<ApplicationEntity>
}

export interface IDatatable extends DatatableData, DatatableProps, DatatableMethods, Vue {}

export interface DatatableOperations {
  add?: boolean
  edit?: boolean
  delete?: boolean
  import?: boolean
  export?: boolean
}

export interface DatatableOptions {
  dialog?: boolean
  operations?: DatatableOperations
}

export interface FilterContainer {
  [index: string]: any
}

export default Vue.extend({
  components: {
    EntityDialog
  },
  data(): DatatableData {
    return {
      page: 1,
      size: 12,
      total: 0,
      items: [],
      clickedEntity: null,
      selectedItems: [],
      windowHeight: 0,
      filtersVisible: false,
      isCodFilterEnabled: this.createParcelModel ?
        this.createParcelModel.createParcelModelExtensions.cashOnDelivery.value : false,
      sort: undefined
    }
  },
  props: {
    datatableId: {
      type: String,
      default: null
    },
    createParcelModel: {
      type: CreateParcelModel
    },
    fields: {
      type: Array as () => FieldDescription[],
      default: () => [] as FieldDescription[]
    },
    options: {
      type: Object as () => DatatableOptions,
      default: () => {
        return {} as DatatableOptions
      }
    },
    entityService: {
      type: EntityService
    },
    selection: {
      type: Boolean,
      default: false
    },
    isCodFilterVisible: {
      type: Boolean,
      default: false
    },
    toolbar: {
      type: Boolean,
      default: true
    },
    footer: {
      type: Boolean,
      default: true
    },
    pickupDialog: {
      type: Boolean,
      default: false
    },
    highlightCurrentRow: {
      type: Boolean,
      default: true
    },
    tableHeight: {
      type: Number
    },
    resolveRowClass: {
      type: Function,
      default: () => "default-background-color"
    },
    resolveCellStyle: {
      type: Function,
      default: () => ""
    },
    rowSelectable: {
      type: Function,
      default: () => true
    },
    filter: {
      type: Object as () => FilterContainer,
      default: () => {
        return {}
      }
    },
    pageSizes: {
      default: () => [12, 24, 48]
    },
    getData: {
      type: Function
    },
    handleFilter: {
      type: Function
    },
    indexed: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clearSelection() {
      const table = this.$refs.table as any
      table.clearSelection()
    },
    getRowRealIndex(index: number) {
      return index + 1 + (this.page - 1) * this.size
    },
    cellClick(value: any) {
      this.$emit("cellClick", value)
    },
    clearFilters() {
      Object.keys(this.filter).forEach(key => (this.filter[key] = undefined))
      this.$emit("update:filter", this.filter)
      this.filtersVisible = false
      this.refreshData(true)
    },
    handleSelectionChange(val: any) {
      this.selectedItems = val
      this.$emit("update:selectedItems", this.selectedItems)
    },
    getDate(date: any) {
      return moment(new Date(date)).format("DD.MM.YYYY")
    },
    getTime(date: any) {
      return moment(new Date(date)).format("HH:mm")
    },
    formatDate(date: any, field: FieldDescription) {
      return moment(new Date(date)).format(field.hasTime ? "DD.MM.YYYY HH:mm" : "DD.MM.YYYY")
    },
    buildFilters() {
      const vm = this
      const filters: Filter[] = []
      vm.fields
        .filter(field => exists(vm.filter[field.fieldName!]) && vm.filter[field.fieldName!].toString().length > 0)
        .forEach(field => {
          if (field.fieldType === FieldTypeEnum.DATE) {
            filters.push(new Filter(field.fieldName! + "From", vm.filter[field.fieldName!][0].getTime()))
            filters.push(new Filter(field.fieldName! + "To", vm.filter[field.fieldName!][1].getTime()))
          } else {
            filters.push(new Filter(field.fieldName!, vm.filter[field.fieldName!]))
          }
        })
      if (exists(vm.filter["company"]) && vm.filter["company"] !== "") {
        filters.push(new Filter("company", vm.filter["company"]))
      } else if (exists(vm.filter["office"]) && vm.filter["office"] !== "") {
        filters.push(new Filter("office", vm.filter["office"]))
      } else if (
        exists(vm.filter["employee"]) &&
        vm.filter["employee"] !== "" &&
        !exists(vm.fields[vm.fields.findIndex(f => f.fieldName === "employee")])
      ) {
        filters.push(new Filter("employee", vm.filter["employee"]))
      }
      return filters
    },
    refreshData(enableReloadPage?: boolean) {
      const vm = this
      if (exists(this.getData)) {
        this.getData(vm.page, vm.size, this)
      } else {
        vm.startLoad()
        let filters = vm.buildFilters()
        if (exists(this.handleFilter)) {
          filters = this.handleFilter(filters) || filters
        }
        if (enableReloadPage) {
          vm.page = 1
        }
        const data = vm.pickupDialog
          ? vm.entityService.getPagePickup(vm.page, vm.size, filters, vm.sort)
          : vm.entityService.getPage(
              vm.page,
              vm.size,
              filters,
              vm.sort,
              vm.isCodFilterVisible ? vm.isCodFilterEnabled : null
            )
        data
          .then((response: AxiosResponse<Page<ApplicationEntity>>) => {
            vm.endLoad()
            vm.items = response.data.content
            vm.total = response.data.totalElements
            vm.selectedItems.forEach((selectedItem: DatatableEntity, index: number) => {
              const item = vm.items.find(item => exists(item.id) && item.id === selectedItem.id)
              if (exists(item)) {
                vm.selectedItems[index] = item!
              }
            })
            vm.$emit("update:selectedItems", this.selectedItems)
          })
          .catch(error => {
            vm.endLoad()
            if (error.message === "Network Error") {
              vm.$error(vm.$t("datatable.backend_unavailable"))
            } else {
              vm.$error(error.message)
            }
          })
      }
    },
    handleCurrentClick(val: any) {
      this.clickedEntity = val
    },
    importFile() {
      this.$emit("import")
    },
    exportFile() {
      const vm = this
      vm.startLoad()
      this.entityService
        .export()
        .then(response => {
          vm.endLoad()
          vm.handleFileResponse(response)
        })
        .catch(() => vm.endLoad())
    },
    handleFileResponse(response: any) {
      const filename = response.headers["content-disposition"].match(/attachment; filename=(.*)/)[1]
      const contentType = response.headers["content-type"]
      const blob = new Blob([response.data], { type: contentType })
      saveAs(blob, filename)
    },
    editEntity(entity: any) {
      const entityDialog = this.$refs.entityDialog as IEntityDialog
      entityDialog.actions.editAction = true
      entityDialog.actionName = this.$t("datatable_entity.edit") as any
      entityDialog.editEntity(entity)
    },
    deleteEntity(entity: any) {
      const entityDialogMethods = this.$refs.entityDialog as IEntityDialog
      entityDialogMethods.deleteEntity(entity)
    },
    addEntity() {
      const entityDialog = this.$refs.entityDialog as IEntityDialog
      entityDialog.actions.addAction = true
      entityDialog.actionName = this.$t("datatable_entity.add") as any
      entityDialog.addEntity()
    },
    addFilter(field: string, filter: any) {
      this.filter[field] = filter
      this.$forceUpdate()
    },
    filterList(): any {
      const vm = this
      return vm.fields
        .filter(field => exists(vm.filter[field.fieldName!]) && vm.filter[field.fieldName!].length > 0)
        .map(field => {
          return {
            field: field.fieldPrettyName,
            value: vm.filter[field.fieldName!],
            type: field.fieldType
          }
        })
    },
    setSort(sort: any = null) {
      if (exists(sort) && !exists(sort!.prop)) {
        this.sort = undefined
      } else if (exists(sort)) {
        this.sort = sort
      } else {
        const field = this.fields.find(field => field.sortable! && notEmpty(field.defaultSort))
        if (exists(field)) {
          this.sort = {
            prop: field!.fieldName,
            order: field!.defaultSort
          }
        }
      }
    }
  },
  computed: {
    datatableIdExists(): boolean {
      return exists(this.datatableId)
    },
    displayedFields(): FieldDescription[] {
      return this.fields.filter(filter => filter.displayed)
    },
    getTableHeight(): number {
      if (exists(this.tableHeight)) {
        return this.tableHeight
      }
      return this.windowHeight - 122 - 45 - 32 - 16
    },
    hasOperations(): boolean {
      return exists(this.options) && exists(this.options.operations)
    },
    hasAdd(): boolean {
      return this.hasOperations && exists(this.options.operations!.add)
    },
    hasEdit(): boolean {
      return this.hasOperations && exists(this.options.operations!.edit)
    },
    hasDelete(): boolean {
      return this.hasOperations && exists(this.options.operations!.delete)
    },
    hasImport(): boolean {
      return this.hasOperations && exists(this.options.operations!.import)
    },
    hasExport(): boolean {
      return this.hasOperations && exists(this.options.operations!.export)
    }
  },
  watch: {
    clickedEntity: {
      handler(newVal) {
        this.$emit("entitySelected", newVal)
      }
    }
  },
  created() {
    const field = this.fields.find(field => field.sortable! && notEmpty(field.defaultSort))
    if (exists(field)) {
      const sort = {
        prop: field!.fieldName,
        order: field!.defaultSort
      }
      this.setSort(sort)
    } else {
      this.refreshData(true)
    }
  },
  mounted() {
    this.windowHeight = window.innerHeight
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowHeight = window.innerHeight
      })
    })
  }
})
